import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hot",
  "use": "icon-hot-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-hot\"><defs><style type=\"text/css\"></style></defs><path d=\"M414.72 981.333333S-1.706667 889.813333 184.32 435.413333c0 0 42.666667 50.56 36.48 74.88 0 0 33.066667-114.773333 104.533333-183.253333C386.773333 267.946667 449.066667 102.4 391.68 42.666667c0 0 284.8 59.733333 316.586667 359.04 0 0 36.48-95.36 111.146666-104.746667a204.586667 204.586667 0 0 0 0 130.986667s235.946667 403.84-170.666666 540.373333c0 0 121.813333-138.453333-136.533334-375.893333 0 0-61.013333 128-97.28 171.946666-0.213333 0-101.973333 114.133333-0.213333 216.96z\" p-id=\"1303\" fill=\"#d81e06\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/hot.svg
// module id = j1mB
// module chunks = 2